import { UntypedFormControl } from '@angular/forms';

export interface CustomFormGroup {
	[key: string]: UntypedFormControl;
}
